import React from 'react';
import africaNetwork from '../../assets/home/africa-network.png';

const AfricaSection = () => (
  <section className="gh-section gh-africa">
    <div className="gh-section__inner gh-africa__grid">
      <div className="gh-africa__text">
        <span className="eyebrow">Connected Africa</span>
        <h2 className="gh-section__title">Powering Africa&apos;s connected future.</h2>
        <p className="gh-section__sub">
          Pulsar is bridging the digital divide by enabling internet access and smart
          energy metering through a single innovative device designed for sub-Saharan
          Africa — combining energy infrastructure and digital connectivity into one
          solution.
        </p>
      </div>
      <div className="gh-africa__visual">
        <img src={africaNetwork} alt="GRIDx connectivity across Africa" loading="lazy" />
      </div>
    </div>
  </section>
);

export default AfricaSection;
